import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { TitleHeader } from 'web-library';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import { useGetUserAuthorities } from '../../api-refactored/user/useGetUserAuthorities';
import LoadingComponent from '../../components/LoadingComponent';
import CandidateBlacklisting from '../../modules/admin/components/CandidateBlacklist/CandidateBlacklisting';
import RouteKey from '../../routes/key';

const { error } = RouteKey.child;
const { generic } = RouteKey.error.child;

const CandidateBlacklistPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [hasView, setHasView] = useState<boolean>(false);

  const { data: userAuthoritiesData = [] } = useGetUserAuthorities();

  useEffect(() => {
    if (!userAuthoritiesData.includes(AUTHORITY_NAMES.CP_ADMIN_CANDIDATE_BLACKLIST_VIEW)) {
      history.push(`/${error}/${generic}`);
    } else {
      setHasView(true);
    }
  }, [history, userAuthoritiesData]);

  return (
    <>
      <TitleHeader title={t('admin->>CandidateBlacklist.CandidateBlacklist')} />
      {hasView ? <CandidateBlacklisting /> : <LoadingComponent />}
    </>
  );
};

export default CandidateBlacklistPage;
